import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';

import { AuditsFilters } from '@gutwin-audit/shared/models/filters-audits.model';

import { FilterModuleService } from '@gutwin-audit/shared/services/filter-module.service';
import { TemplateService } from '@gutwin-audit/shared/services/template.service';

@Injectable()
export class TemplatesResolve implements Resolve<any> {
  constructor(
    private filterService: FilterModuleService,
    private notificationsService: NotificationsService,
    private templateService: TemplateService,
    private translateService: TranslateService
  ) { }

  resolve (route: ActivatedRouteSnapshot) {
    this.filterService.getQueryParams(route.queryParams);

    const page = this.filterService.page;
    const limit = this.filterService.limit;
    const filters = this.filterService.filters;

    return this.templateService.getTemplates(page, filters as AuditsFilters, limit)
      .catch(error => {
        this.fetchErrorTranslation()
          .then((translation: any) => {
            this.notificationsService.error(translation.title, translation.text);
          });
        return [];
      });
  }

  fetchErrorTranslation(): Promise<any> {
    return this.translateService.get([
      'GLOBAL.ERROR.CONNECTION',
      'TEMPLATES_LIST.ERROR.LOAD_TEMPLATES'
    ])
      .toPromise()
      .then((translation: Array<string>) => {
        return {
          title: translation['GLOBAL.ERROR.CONNECTION'],
          text: translation['TEMPLATES_LIST.ERROR.LOAD_TEMPLATES']
        };
      });
  }
}
